import React from "react";
import { Link } from "react-router-dom";
import "./index.less";

export default props => {
  const {
    post: {
      videoId,
      title,
      mediaDetails: { videoThumbnail: { sourceUrl } = {} } = {}
    } = {}
  } = props || {};

  return (
    <Link to={`/videos/${videoId}`} key={videoId} className="redirect-card">
      {sourceUrl && (
        <img
          src={
            sourceUrl // If a featured image exists, display it.
          }
          alt={title}
          className="image"
        />
      )}
      <h3 className="heading">{title}</h3>
    </Link>
  );
};
